module.exports = __webpack_public_path__ + "img/why-icon-2.e00a8b5d.svg";